import { FF_HEADSPACE_PROMOTION } from '@app/constant/experiments';
import LaunchDarkly from '@module/launchdarkly';

const menu = [
  { href: '/legal/terms', label: 'Terms of Service' },
  { href: '/legal/privacy', label: 'Privacy & Cookie Statement' },
  { href: '/legal/takedown', label: 'Notice and Takedown Policy' },
  { href: '/legal/disclosure', label: 'Responsible Disclosure Policy' },
  { href: '/legal/advertising', label: 'Advertising Terms &\xa0Conditions' },
];

if (LaunchDarkly.getVariant(FF_HEADSPACE_PROMOTION)) {
  menu.push({
    href: '/legal/headspace-promotion',
    label: 'Terms for Headspace promotion',
  });
}

export default menu;
